import Vuex from 'vuex';

import production from './modules/producer/production';
import preview from './modules/producer/preview';
import posts from './modules/producer/posts';
import clients from './modules/producer/clients';
import live from './modules/producer/live';
import screens from './modules/producer/screens';
import timeline from './modules/producer/timeline';
import drag from './modules/producer/drag';

import assets from './modules/shared/assets';
import tagboards from './modules/shared/tagboards';
import themes from './modules/shared/themes';
import panels from './modules/shared/panels';
import polls from './modules/shared/polls';
import user from './modules/shared/user';
import graphics from './modules/producer/graphics';
import shoppable from './modules/shared/shoppable';

export default new Vuex.Store({
  modules: {
    // Producer Stores
    production,
    preview,
    posts,
    clients,
    live,
    screens,
    timeline,
    drag,

    // Shared Stores
    assets,
    tagboards,
    themes,
    panels,
    polls,
    user,
    graphics,
    shoppable,
  },
});
